import { DatosGeneralesText } from '../../UtilitiesComponents/DatosGeneralesText';
import { Dispatch, SetStateAction, useEffect } from 'react';
import { useLazyGetEmpresaInfoByIdQuery } from '../../../features/empresas/empresaApi';
import { CircularProgress } from '@mui/joy';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import Groups2RoundedIcon from '@mui/icons-material/Groups2Rounded';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import NumbersRoundedIcon from '@mui/icons-material/NumbersRounded';
import SignpostRoundedIcon from '@mui/icons-material/SignpostRounded';
import ToggleOnRoundedIcon from '@mui/icons-material/ToggleOnRounded';
import FmdGoodRoundedIcon from '@mui/icons-material/FmdGoodRounded';
import DialpadRoundedIcon from '@mui/icons-material/DialpadRounded';
import AccountBalanceRoundedIcon from '@mui/icons-material/AccountBalanceRounded';
import CategoryRoundedIcon from '@mui/icons-material/CategoryRounded';
import StoreMallDirectoryRoundedIcon from '@mui/icons-material/StoreMallDirectoryRounded';

interface Props {
    setOpenCard: Dispatch<SetStateAction<boolean>>;
    empresaSelected: number | null;
}

export function GeneralInformationCard({ setOpenCard, empresaSelected }: Props) {
	const [getDatosGenerales, { data: datosGenerales, isLoading, isSuccess, isFetching }, lastPromiseInfo] = useLazyGetEmpresaInfoByIdQuery();

    const iconSize = 20;
    const stateColor = datosGenerales?.datosGenerales.estado === "Inactiva" ? "red" : "green"

    const fetchDatosGenerales = async () => {
        try {
            console.log(empresaSelected)
            if(empresaSelected) {
                const request = { empresaId: empresaSelected, section: "general" };
                await getDatosGenerales(request);
            }
        } catch (error) {
            console.error(error)
        }
    }

    useEffect(() => {
        fetchDatosGenerales();
    }, [empresaSelected]);

    return (
        <div className="flex flex-col w-[350px] h-[430px] rounded border-2 border-slate-200 bg-white z-50">
            <div className="flex justify-end bg-gray-100 rounded">
                <button 
                onClick={() => setOpenCard(false)}>
                    <CloseRoundedIcon  />
                </button>
            </div>

            {isLoading || isFetching || !isSuccess
            ?
            <div className="flex items-center w-full justify-center h-full">
                <CircularProgress />
            </div>
            :

            <div className="h-full p-2">
                <p className="font-semibold text-lg text-center mb-2">{datosGenerales?.datosGenerales.nombre}</p>

                <DatosGeneralesText 
                    icon={<StoreMallDirectoryRoundedIcon sx={{ height: iconSize, width: iconSize }}/>}
                    label={"Sucursal: "}
                    text={datosGenerales.datosGenerales.sucursal ?? "Sin sucursal"}/>

                <DatosGeneralesText 
                    icon={<Groups2RoundedIcon sx={{ height: iconSize, width: iconSize }}/>}
                    label={"No. Trabajadores: "}
                    text={`${datosGenerales.datosGenerales.numeroTrabajadores} trabajadores`}/>

                <DatosGeneralesText
                    icon={<ToggleOnRoundedIcon sx={{ height: iconSize, width: iconSize, color: stateColor}}/>}
                    label={"Estado: "}
                    text={datosGenerales.datosGenerales.estado}/>

                <DatosGeneralesText 
                    icon={<CategoryRoundedIcon sx={{ height: iconSize, width: iconSize }}/>}
                    label={"Tipo: "}
                    text={datosGenerales.datosGenerales.tipo}/>

                <DatosGeneralesText 
                    icon={<HomeRoundedIcon sx={{ height: iconSize, width: iconSize }}/>}
                    label={"Calle: "}
                    text={datosGenerales.datosGenerales.calle ?? "Sin calle"}/>

                <DatosGeneralesText 
                    icon={<SignpostRoundedIcon sx={{ height: iconSize, width: iconSize }}/>}
                    label={"Colonia: "}
                    text={datosGenerales.datosGenerales.colonia ?? "Sin colonia"}/>

                <DatosGeneralesText 
                    icon={<NumbersRoundedIcon sx={{ height: iconSize, width: iconSize }}/>}
                    label={"No. Exterior: "}
                    text={datosGenerales.datosGenerales.numeroExterior ?? "Sin número exterior"}/>

                <DatosGeneralesText 
                    icon={<DialpadRoundedIcon sx={{ height: iconSize, width: iconSize }}/>}
                    label={"Codigo Postal: "}
                    text={datosGenerales.datosGenerales.codigoPostal ?? "Sin código postal"}/>

                <DatosGeneralesText 
                    icon={<AccountBalanceRoundedIcon sx={{ height: iconSize, width: iconSize }}/>}
                    label={"Municipio: "}
                    text={datosGenerales.datosGenerales.municipio ?? "Sin municipio"}/>

                <DatosGeneralesText 
                    icon={<FmdGoodRoundedIcon sx={{ height: iconSize, width: iconSize }}/>}
                    label={"Coordenadas: "}
                    text={datosGenerales.datosGenerales.coordenadas ?? "Sin coordenadas"}/>
            </div>
            }
        </div>
    );
}